import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23 24.047v-3.804h-2.775l-1.428-1.648-1.438 1.648h-9.15v-7.681H5.256l3.661-8.648h3.535l1.26 2.964V3.914h4.376l.76 2.235.764-2.235H23V.047H0v23.995h23zm-2.31-4.765H23l-3.053-3.376L23 12.567h-2.269l-1.883 2.15-1.869-2.15H14.67l3.033 3.36-3.033 3.36h2.243l1.894-2.166 1.884 2.166zm.543-3.376L23 17.866v-3.91l-1.767 1.945zm-10.29 1.817v-1.046h3.63v-1.516h-3.63v-1.046h3.722v-1.553h-5.48v6.714h5.48v-1.553zm10.32-6.133H23V4.875h-2.704L18.853 9.06 17.42 4.875h-2.75v6.715h1.737V6.888l1.656 4.702h1.544l1.656-4.712zm-8.573 0h1.975l-2.84-6.715H9.56L6.72 11.59h1.93l.53-1.342h2.963l.542 1.342zm-1.15-2.848H9.794l.877-2.197.876 2.197z"
    }, null, -1)
  ])))
}
export default { render: render }